import { useEffect, useState } from "react";

const STORAGE_KEY = "monolith.recent.v1";
const MAX_RECENT = 6;

export const useRecentlyViewed = () => {
    const [items, setItems] = useState(() => {
        try {
            const raw = sessionStorage.getItem(STORAGE_KEY);
            return raw ? JSON.parse(raw) : [];
        } catch (err) {
            console.warn("useRecentlyViewed: failed to read sessionStorage", err);
            return [];
        }
    });

    const track = (product) => {
        setItems((prev) => {
            const filtered = prev.filter((i) => i.id !== product.id);
            const next = [
                {
                    id: product.id,
                    slug: product.slug,
                    name: product.name,
                    price: product.price,
                    category: product.category,
                    image: product.images?.[0],
                },
                ...filtered,
            ].slice(0, MAX_RECENT);
            try {
                sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
            } catch (err) {
                console.warn("useRecentlyViewed: failed to persist", err);
            }
            return next;
        });
    };

    useEffect(() => {
        const onStorage = () => {
            try {
                const raw = sessionStorage.getItem(STORAGE_KEY);
                setItems(raw ? JSON.parse(raw) : []);
            } catch {
                setItems([]);
            }
        };
        window.addEventListener("storage", onStorage);
        return () => window.removeEventListener("storage", onStorage);
    }, []);

    return { items, track };
};
